import xingLogo from '../../assets/xing-logo.svg';
import linkedInLogo from '../../assets/linkedin-logo.svg';
import './header.scss';
function Header() {
    return (
        <div className="header">
            <div className="text-content">
                <h4>Hey, I'm</h4>
                <h1>Sascha Wippis</h1>
                <p>Software-engineer</p>
                <small>based in Hamburg</small>
            </div>

            <div className="socials">
                <a
                    target="_blank"
                    href="https://www.xing.com/profile/Sascha_Wippis"
                    rel="noopener"
                >
                    <img src={xingLogo} alt="Sascha Wippis on XING" />
                </a>

                <a
                    target="_blank"
                    href="https://www.linkedin.com/in/sascha-wippis-3855b5147/"
                    rel="noopener"
                >
                    <img src={linkedInLogo} alt="Sascha Wippis on LinkedIn" />
                </a>
            </div>
        </div>
    );
}

export default Header;